import { ChevronRightIcon } from '@chakra-ui/icons';
import {
  Box,
  HStack,
  LinkBox,
  LinkOverlay,
  Stack,
  useBreakpointValue,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { useSmartyContext } from '../../components/Geolocation/geolocation.context';
import { isExternalLink } from '../../utils/link.utils';
import { WLH3, WLText } from '..';
import ImageHandler from '../ImageHandler';

interface ProductProps {
  href: string;
  image: StaticImageDef | React.ReactElement;
  actionLabel: string;
  index?: number | string;
  children?: React.ReactNode | React.ReactNode[];
}

const Product: React.FC<ProductProps> = ({
  href,
  image,
  actionLabel,
  children,
  index,
}) => {
  const sizes = useBreakpointValue({
    base: 'sm',
    md: 'md',
    lg: 'lg',
  });

  const styles = useMultiStyleConfig('Product', { size: sizes });

  const { loaded, location } = useSmartyContext();
  const statesWithGraphics = [
    'AL',
    'AR',
    'AZ',
    'CO',
    'FL',
    'GA',
    'IA',
    'IL',
    'IN',
    'KY',
    'LA',
    'MI',
    'MS',
    'NC',
    'NJ',
    'OH',
    'OK',
    'OR',
    'PA',
    'SC',
    'TN',
    'TX',
    'VA',
    'WV',
  ];
  return (
    <Stack
      as={LinkBox}
      role="group"
      sx={styles.product}
      style={{ marginLeft: '0px' }}
      _hover={{
        cursor: href ? 'pointer' : 'auto',
      }}
    >
      <VStack sx={styles.content}>
        <Box __css={styles.decor}>
          <Box __css={styles.gradientLeft} />
          <Box __css={styles.gradientRight} />
        </Box>
        <Box __css={styles.shadow} />
        <Box marginTop={0} sx={styles.imgBox}>
          <Box __css={styles.color} />
          <Box
            __css={styles.imgWrapper}
            height="full"
            sx={{ '[data-gatsby-image-wrapper]': { width: 'full' } }}
          >
            <ImageHandler image={image} />
          </Box>
        </Box>
        <Box __css={styles.action}>
          <HStack
            alignItems={'center'}
            sx={{
              transition: 'all 0.3s ease-in-out',
            }}
          >
            <WLH3
              color="#00549F"
              fontSize={{ base: '20px', md: '24px' }}
              textTransform="capitalize"
              textAlign={'center'}
            >
              {href ? (
                <LinkOverlay href={href} isExternal={isExternalLink(href)}>
                  {actionLabel} <span> &#8250;</span>
                </LinkOverlay>
              ) : (
                actionLabel
              )}
            </WLH3>
          </HStack>
        </Box>
        <Box style={{ margin: '0px' }} sx={styles.copy}>
          {href === '/insurance/medicare-supplement-insurance/' &&
          loaded &&
          location &&
          statesWithGraphics.includes(location) &&
          location === 'TX'
            ? `We offer several insurance plan options that can help fill some of the gaps in Medicare coverage.`
            : children}
          {href === '/insurance/medicare-supplement-insurance/' &&
            loaded &&
            location &&
            statesWithGraphics.includes(location) && (
              <>
                <br />
                <br />
                <WLText textAlign={'left'} fontSize="xs" color="black">
                  632977
                </WLText>
              </>
            )}
        </Box>
      </VStack>
    </Stack>
  );
};

export default Product;
